import { parentApi } from './parentApi';

export async function openFamilyReport(studentId, reportId) {
  const res = await parentApi.reportLink(studentId, reportId);
  const url = res.data?.data?.url;
  if (url) window.open(url, '_blank', 'noopener,noreferrer');
}
